import TModal from "./TModal";

export default TModal;
